export const timelineItems = [
  {
    id: "tl-1",
    date: "09-10",
    time: "09:20",
    tag: "截图",
    title: "新增 3 组带时间戳的对话截图",
    desc: "按发生顺序重排，补上此前缺失的两段中间对话，前后衔接更完整。",
  },
  {
    id: "tl-2",
    date: "09-09",
    time: "21:40",
    tag: "录音",
    title: "录音节选完成文字转写",
    desc: "标注 4 处关键时间点，并把背景音比对结果同步到对应段落。",
  },
  {
    id: "tl-3",
    date: "09-08",
    time: "18:05",
    tag: "文件",
    title: "12 页材料扫描件归档",
    desc: "逐页摘要已附在文件说明中，方便直接定位到具体字段。",
  },
  {
    id: "tl-4",
    date: "09-07",
    time: "14:30",
    tag: "对比",
    title: "说法差异对照表更新至第 7 版",
    desc: "新增两行对比，其中一行的表述变化较为明显，已在表中高亮。",
  },
  {
    id: "tl-5",
    date: "09-05",
    time: "11:10",
    tag: "线索",
    title: "读者补充两条节点细节",
    desc: "已进入核验队列，与既有材料交叉比对后决定是否纳入主索引。",
  },
  {
    id: "tl-6",
    date: "09-03",
    time: "20:00",
    tag: "汇总",
    title: "首批材料完成分类索引",
    desc: "把截图、录音、文件按类型分区，形成当前总表的雏形。",
  },
];